<template>
  <section>
    <h2 class="h3 mb-3  mt-5">Draft Rules</h2>
    <div class="f-form">

      <div class="f-form__half">
        <f-text
          id="firstRoundRunsPerPerson"
          label="First Round Runs Per Person"
          type="number"
          :value="value.first_round_runs_per_person"
          hint="Leave blank or 0 if unlimited"
          :error="e('first_round_runs_per_person')"
          @input="update('first_round_runs_per_person', $event)"
        />
      </div>

      <div class="f-form__half">
        <f-text
          id="totalRunsPerHorse"
          label="Total Runs Per Horse"
          type="number"
          :value="value.total_runs_per_horse"
          hint="Leave blank or 0 if unlimited"
          :error="e('total_runs_per_horse')"
          @input="update('total_runs_per_horse', $event)"
        />
      </div>

    </div>
  </section>
</template>

<script>
import FText from '@/components/FormFields/FText'

export default {
  name: 'DraftRulesSection',
  components: { FText },
  props: {
    value: { type: Object, required: true },
    errors: { type: Object, default: () => ({}) }
  },
  methods: {
    e(field) {
      return this.errors[field] ? this.errors[field][0] : null
    },
    update(field, val) {
      this.$emit('input', { ...this.value, [field]: val })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Drafts/DraftRulesSection.vue